export default __webpack_public_path__ + "static/media/lines-mobile.ab717cf9.svg";